var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 401.294 410.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "neck",
    d: "M566.834,230.549c-11.261,12.137,18.181,41.594,18.181,41.594S525.4,282.2,530.126,281.587s2.279-50.76,2.279-50.76S578.1,218.411,566.834,230.549Z",
    transform: "translate(-339.064 -184.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pants",
    d: "M609.664,356.445l-51.8,26.463-28.132,16.123s-33.163,41.771-39.35,66.527,26.789,70.509,30.523,75.237a56.168,56.168,0,0,1,5.154,7.67c1.289,1.917,12.428-.559,24.592-3.167s-1.614-20.625-1.614-20.625S533.511,485,532.355,484.112c-1.08-.834-4.753-7.693-2.111-10.7a26.809,26.809,0,0,0,5.625-9.193,31.087,31.087,0,0,1,4.326-8.2S587.06,417.961,601.7,405s53.547-4.813,53.547-4.813-18.371,70.461-22.967,75.22-5.092,8.989-3.012,17.055,29.219.4,29.219.4l10.022-27.333s16.271-35.429,25.1-71.984c4.417-18.277-4.017-29.171-13.556-35.494a42.763,42.763,0,0,0-31.025-6.176l-47.885,8.4,33.213-14.308Z",
    transform: "translate(-340.398 -180.581)",
    fill: "#ef6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "left_arm",
    "data-name": "left arm",
    d: "M423.387,292.041l-61.838-19.119s-24.98-32.2-13.212-37.882,26.5,27.837,26.5,27.837l43.068,2.787Z",
    transform: "translate(-345.185 -184.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right_arm",
    "data-name": "right arm",
    d: "M672.538,260.17l54.976-34.164s16.007-37.479,3.183-39.994-18.584,33.644-18.584,33.644l-40.956,13.608Z",
    transform: "translate(-334.38 -185.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shirt",
    d: "M691.681,220.4l1.048,40.491-92.661,16.556c13.63,29.16,10.167,62.347,44.474,76.893L528.909,410.9c5.152-44.465-16.342-77.957-36.432-119.6-24.471-8.87-52.893-2.367-83,10.689l-5.411-42.012,127.984-9.191,21.023,8.037,22.542-9.481C608.746,239.5,656.314,220.788,691.681,220.4Z",
    transform: "translate(-343.234 -184.743)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "right_foot",
    "data-name": "right foot",
    d: "M626.817,486.614c-2.81,2.445-5.426,22.574-5.527,29.879s9.517,9.191,14.773,9.556,4.627,3.571,8.1,6.249,14.873,2.251,29.848-2.8-10.076-21.619-12.257-22.38-11.365-23.537-11.365-23.537S629.628,484.169,626.817,486.614Z",
    transform: "translate(-336.033 -176.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "left_foot",
    "data-name": "left foot",
    d: "M548.677,531.018c3.338,1.654,10.969,20.463,12.917,27.5s-6.878,11.3-11.869,12.987-3.571,4.627-6.249,8.1-13.818,5.946-29.584,4.852,4.27-23.467,6.187-24.755,5.03-25.648,5.03-25.648S545.339,529.365,548.677,531.018Z",
    transform: "translate(-339.792 -174.459)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "face",
    cx: 24.791,
    cy: 24.791,
    r: 24.791,
    transform: "translate(184.2 11.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hair",
    d: "M519.814,219.987a23.583,23.583,0,0,1-.861-19.209c2.437-6.008,7.843-12.042,19.5-13.844,25.43-3.932,38.963,13.881,38.252,19.707s-4.125,19.909-4.125,19.909,1.525-13.334-5.02-13.8-31.926-2.457-38.353,4.282a14.7,14.7,0,0,0-3.834,14.288Z",
    transform: "translate(-339.48 -185.871)",
    fill: "#222"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkater);
export default __webpack_public_path__ + "static/media/skater.a82b80e8.svg";
export { ForwardRef as ReactComponent };